import { createFileRoute } from '@tanstack/react-router';
import {
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { Plus } from 'lucide-react';
import { useMemo, useState } from 'react';

import { SettingsLayout } from '@/components/settings-layout';
import { Button } from '@/components/ui/button/button';
import { GenericTable } from '@/components/ui/generic-table';
import { WithAuthorization } from '@/components/with-authorization';
import { RecipeTagSettingsTable } from '@/features/recipe-tags/components/recipe-tag-settings-table';
import { makeColumns } from '@/features/recipe-tags/utils/make-recipe-tags-settings-table-columns';

export function RecipeTagsSettingsPage() {
  const [isAddOpen, setIsAddOpen] = useState(false);

  const columns = useMemo(() => makeColumns(), []);

  const table = useReactTable({
    data: [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <SettingsLayout
      title="Recipe Tags"
      fallback={<GenericTable table={table} loading={true} />}
      header={
        <WithAuthorization authorizedRoles={['admin', 'editor']}>
          <Button onClick={() => setIsAddOpen(true)}>
            <Plus className="h-4 w-4" />
            Add Tag
          </Button>
        </WithAuthorization>
      }
    >
      <RecipeTagSettingsTable
        isAddOpen={isAddOpen}
        setIsAddOpen={setIsAddOpen}
      />
    </SettingsLayout>
  );
}

export const Route = createFileRoute(
  '/_authenticated/$tenantId/settings/recipe-tags',
)({
  component: RecipeTagsSettingsPage,
});
